var AssetsViewState;
(function (AssetsViewState) {
    AssetsViewState["TABLE"] = "table";
    AssetsViewState["MAPHORIZONTAL"] = "mapHorizontal";
    AssetsViewState["MAPVERTICAL"] = "mapVertical";
})(AssetsViewState || (AssetsViewState = {}));
export default AssetsViewState;
